import Program from "./Program";
import data from "../../constants/careers.json";

function Programs() {
  return (
    <section className="bg-light py-4">
      <div className="container">
        <h2 className="section-title text-center mt-5">Nuestra Oferta Académica</h2>
        <div className="row align-items-center justify-content-center py-2">            
          {data.map((career) => (
            <div className="col-md-6 my-2 my-md-4 d-flex" key={career.id}>
              <Program career={career} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Programs;